import { EdgeLoadEffectiveAllowedHuntTypesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadEffectiveAllowedHuntTypes } from '@/shared/domain'

export function makeLoadEffectiveAllowedHuntTypes(): LoadEffectiveAllowedHuntTypes {
  return new EdgeLoadEffectiveAllowedHuntTypesRepository(makeSupabaseEdgeHttpClient()).execute
}
